import { useSaved } from '../context/SavedContext';

function SaveButton({ item, className = '' }) {
  const { isSaved, toggleSave } = useSaved();
  const saved = isSaved(item.item_id);

  return (
    <button
      className={`save-btn ${saved ? 'save-btn--saved' : ''} ${className}`}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleSave(item); }}
      title={saved ? 'Remove from saved' : 'Save'}
      aria-label={saved ? 'Remove from saved' : 'Save'}
    >
      {saved ? '★ Saved' : '☆ Save'}
    </button>
  );
}

export default SaveButton;
